import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'

interface DragnDropCloseProps {
    startPosition?: number
    startLandscapePosition?: number
    mode: 'portal' | 'widget'
}

const MIN_POSITION = 0

export default /*@__PURE__*/_defineComponent({
  __name: 'DragnDropClose',
  props: {
    startPosition: { default: 0 },
    startLandscapePosition: {},
    mode: {}
  },
  setup(__props: any) {

const props = __props

const buttonRef = ref<HTMLElement | null>(null)
const positionY = ref(props.startPosition)
const dragging = ref(false)
const offsetY = ref(0)
const isPortal = computed(() => props.mode === 'portal')

function startDrag(event: TouchEvent) {
    if (!buttonRef?.value) {
        return
    }
    const { clientY } = event.touches[0]
    dragging.value = true

    offsetY.value = clientY - buttonRef.value.getBoundingClientRect().top
    document.addEventListener('touchmove', onDrag)
    document.addEventListener('touchend', stopDrag)
}

function onDrag(event: TouchEvent) {
    if (!dragging.value || !buttonRef?.value) {
        return
    }
    event.preventDefault()
    const { clientY } = event.touches[0]
    const button = buttonRef.value
    const containerHeight = document.body.getBoundingClientRect().height
    const buttonHeight = button.offsetHeight
    let newY = clientY - offsetY.value

    newY = Math.max(MIN_POSITION, newY)
    newY = Math.min(containerHeight - buttonHeight, newY)

    positionY.value = newY
}

function setStartPosition() {
    const isLandscape = screen.orientation.type.startsWith('landscape')
    if (isLandscape) {
        positionY.value = props.startLandscapePosition ?? props.startPosition
    } else {
        positionY.value = props.startPosition
    }
}

function stopDrag() {
    dragging.value = false
    document.removeEventListener('touchmove', onDrag)
    document.removeEventListener('touchend', stopDrag)
}

onMounted(() => {
    window.addEventListener('orientationchange', setStartPosition)
})

onBeforeUnmount(() => {
    document.removeEventListener('touchmove', onDrag)
    document.removeEventListener('touchend', stopDrag)
    window.removeEventListener('orientationchange', setStartPosition)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref_key: "buttonRef",
    ref: buttonRef,
    class: _normalizeClass([_ctx.$style.button, isPortal.value && _ctx.$style.button_portal, dragging.value && _ctx.$style.active]),
    "data-interface-target": "close-game",
    style: _normalizeStyle({ top: `${positionY.value}px` }),
    "aria-label": "Close game",
    onTouchstart: startDrag
  }, [
    (isPortal.value)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: "chevron_l",
          class: _normalizeClass(_ctx.$style.chevron_icon)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    _createVNode(Icon, {
      name: isPortal.value ? 'fennek' : 'close',
      class: _normalizeClass([_ctx.$style.button_icon])
    }, null, 8, ["name", "class"])
  ], 38))
}
}

})